// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#convalescenceInfoTable {\n  width: 100%;\n}\n#convalescenceInfoTable th {\n  font-weight: normal;\n  text-align: left;\n  font-size: 14px;\n}\n#convalescenceInfoTable td {\n  font-size: 14px;\n}\n", ""]);
// Exports
module.exports = exports;
